import { fleetListTabs } from '../../constants/Common';
import {
  AutoDriveTabs,
  MEDIUM_VALUE,
  defaultSetUpKeys,
} from '../../constants/constant';
import { MapFeature, SetUpKeys, TractorsList } from '../../constants/types';
import { FeedLaneType, feedAmountValueType } from '../../lib/types';
import {
  AUTO_DRIVE_ERROR,
  AUTO_DRIVE_LOGOUT_ERROR_CODES,
  AUTO_DRIVE_MONITOR_ERROR_CODES,
  EXECUTE,
  RESET_STATE,
  SELECTED_IMPLEMENT_NAME,
  SELECTED_IMPLEMENT_TYPE,
  SELECTED_ITEM_NAME,
  SELECTED_ROUTINE,
  SELECTED_TRACTOR,
  SELECTED_TRACTORS,
  SELECTED_VINE_BLOCK,
  SET_ACTIVE_AUTODRIVE_TAB,
  SET_ADD_STEP,
  SET_AUTO_DRIVE_FEEDBACK_PAYLOAD,
  SET_AUTO_DRIVE_FEEDBACK_POP,
  SET_AUTO_DRIVE_INTERRUPT_MESSAGES,
  SET_AUTO_DRIVE_LOADER,
  SET_AUTO_DRIVE_MONITOR_POP,
  SET_AUTO_DRIVE_POP,
  SET_FEED_AMOUNT,
  SET_FEED_LANES,
  SET_IMPLEMENT,
  SET_LOADER_FOR_IMPLEMENT_CHANGE,
  SET_PINNED_TRACTORS,
  SET_SELECTED_FEED_LANES,
  // SET_SELECTED_IMPLEMENT_WIDTH,
  SET_SELECTED_OPENED_FLEET_TAB,
  SET_SELECTED_TRACTOR_LOCATION,
  SET_SETUP_KEYS,
  SET_SHOW_CONNECT_LOADER,
  SET_SHOW_CONNECT_TRY_AGAIN_POP,
  // SET_SHOW_IMPLEMENT_HANDLER,
  SET_SHOW_PATH_MODAL,
  SET_SHOW_PRESENT_COMMAND,
  SET_SHOW_REMOTE_DRIVE_DETAILS,
  SET_SHOW_ROUTINE,
  SET_SHOW_SNAPSHOT,
  SET_SHOW_TERM_AND_COND,
  SET_TRIGGERED_GUARDRAIL,
  SET_TRIGGER_TO_STARTING_POINT,
  SET_WAY_POINTS_FOR_REMOTE_AV,
  SHOW_AUTO_DRIVE_POOR_CONNECTIVITY_LOADER,
  SHOW_TRACTOR_COMMAND_LOADER,
  SHOW_TRACTOR_START,
  SNAP_SHOT_INITIATED,
} from './actions';

interface InitialStateType {
  connected: boolean;
  showRemoteDriveDetails: boolean;
  showPresentCommand: string;
  implement: string;
  tractors: any[];
  setUpKeys: SetUpKeys;
  title: string;
  triggeredGuardrail: string;
  showPathModal: boolean;
  showTractorStart: any;
  showTractorCommandLoader: any;
  showSnapshot: boolean;
  snapShotInitiated: any;
  pinnedTractors: any[];
  selectedRoutine: any;
  showTermAndCond: boolean;
  showRoutine: boolean;
  autoDriveInterruptMsgs: any;
  autoDriveMonitorPop: boolean;
  showAutoDrivePop: boolean;
  showAutoDriveFeedBackPop: boolean;
  feedBackPayload: { tractor_id: number; drive_action_uuid: string };
  autoDriveMonitorErrorCodes: any;
  showConnectLoader: boolean;
  selectedTractorLocation: any;
  selectedTractors: TractorsList[];
  selectedTractor: TractorsList | null;
  selectedOpenedFleetTab: string;
  loaderForImplementChange: string;
  activeAutoDriveTab: string;
  triggerToStartingPoint: boolean;
  showConnectTryAgainPop: boolean;
  showAutoDrivePoorConnectivityLoader: boolean;
  waypointsForRemoteAv: MapFeature[];
  autoDriveLoader: boolean;
  selectedImplementType: string;
  feedLanes: FeedLaneType[];
  selectedFeedLanes: FeedLaneType[];
  feedAmount: feedAmountValueType;
  // selectedImplementWidth: number;
  // showImplementWidthHandler: boolean;
}
interface Action {
  type: string;
  payload?: any;
}

export const initialState: InitialStateType = {
  connected: false,
  showRemoteDriveDetails: false,
  showPresentCommand: '', // '' | 'GOTO' | 'ROUTINE'
  implement: '',
  tractors: [],
  setUpKeys: defaultSetUpKeys,
  triggeredGuardrail: '',
  showPathModal: false,
  title: 'RemoteDriveContext',
  showTractorStart: {},
  showTractorCommandLoader: {},
  showSnapshot: false,
  snapShotInitiated: null,
  pinnedTractors: [],
  selectedRoutine: null,
  showTermAndCond: false,
  showRoutine: false,
  autoDriveInterruptMsgs: {},
  // autoDriveInterruptMsgs: JSON.parse(
  //   '{"remote_estop_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"autonomy_disabled","category":"system_pause","type":"hard"}},"autonomy_disabled_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"remote_estop","category":"system_pause","type":"hard"}},"guardrails_human_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_human","category":"system_pause","type":"hard"}},"guardrails_human_soft_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_human","category":"system_pause","type":"soft"}},"guardrails_human_front_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_human_front","category":"system_pause","type":"hard"}},"guardrails_human_front_soft_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_human_front","category":"system_pause","type":"soft"}},"guardrails_path_presence_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_path_presence","category":"system_pause","type":"hard"}},"guardrails_path_presence_soft_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_path_presence","category":"system_pause","type":"soft"}},"guardrails_implement_collision_soft_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_implement_collision","category":"system_pause","type":"soft"}},"guardrails_implement_collision_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_implement_collision","category":"system_pause","type":"hard"}},"guardrails_slip_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"guardrails_slip","category":"system_pause","type":"hard"}},"firmware_fault_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"firmware_fault","category":"system_pause","type":"hard"}},"lost_localization_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"lost_localization","category":"system_pause","type":"hard"}},"lost_localization_soft_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"lost_localization","category":"system_pause","type":"soft"}},"tractor_moved_off_path_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"tractor_moved_off_path","category":"system_pause","type":"hard"}},"tractor_lost_connection_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"tractor_lost_connection","category":"system_pause","type":"hard"}},"steer_calibration_error_hard_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"steer_calibration_error","category":"system_pause","type":"hard"}},"seatbelt_state_change_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"seatbelt_state_change","category":"system_pause","type":"hard"}},"driver_occupancy_state_change_pause_34":{"category":"autodrive_interrupt_msg","message":"pause","organization_id":2,"tractor_id":34,"timestamp":1669201914351,"metadata":{"details":"driver_occupancy_state_change","category":"system_pause","type":"hard"}}}',
  // ),
  autoDriveMonitorPop: false,
  showAutoDrivePop: false,
  showAutoDriveFeedBackPop: false,
  feedBackPayload: { tractor_id: 0, drive_action_uuid: '' },
  autoDriveMonitorErrorCodes: null,
  // autoDriveMonitorErrorCodes: {
  //   errors: [7001, 7002, 76100, 76200],
  //   message: '7001,7002,76100,76200',
  //   organization_id: 2,
  //   tractorId: 34,
  // },
  showConnectLoader: false,
  selectedTractorLocation: null,
  selectedTractors: [],
  selectedTractor: null,
  selectedOpenedFleetTab: fleetListTabs.fleetListTractorsList,
  loaderForImplementChange: '',
  activeAutoDriveTab: AutoDriveTabs.Parameter,
  triggerToStartingPoint: false,
  showConnectTryAgainPop: false,
  showAutoDrivePoorConnectivityLoader: false,
  waypointsForRemoteAv: [],
  autoDriveLoader: false,
  selectedImplementType: '',
  feedLanes: [],
  selectedFeedLanes: [],
  feedAmount: MEDIUM_VALUE,
  // selectedImplementWidth: 0,
  // showImplementWidthHandler: false,
};

export default function reducer(state: InitialStateType, action: Action) {
  const { type, payload } = action;
  switch (type) {
    case SELECTED_TRACTOR:
      return {
        ...state,
        selectedTractor: payload,
      };

    case SELECTED_TRACTORS:
      return {
        ...state,
        selectedTractors: payload,
      };
    // to get the implement details
    case SET_IMPLEMENT:
      return { ...state, implement: payload };
    case SELECTED_IMPLEMENT_NAME:
      return { ...state, selectedImplementName: payload };
    case SELECTED_IMPLEMENT_TYPE:
      return { ...state, selectedImplementType: payload };
    case SET_SHOW_PRESENT_COMMAND:
      return { ...state, showPresentCommand: payload };
    case SET_SETUP_KEYS:
      return { ...state, setUpKeys: { ...state.setUpKeys, ...payload } };
    case SET_SHOW_REMOTE_DRIVE_DETAILS:
      return { ...state, showRemoteDriveDetails: payload };
    case EXECUTE:
      return { ...state, ...payload };
    case SELECTED_ITEM_NAME:
      return { ...state, selectedItemName: payload };
    case SELECTED_VINE_BLOCK:
      return { ...state, selectedVineBlockName: payload };
    case SET_SHOW_PATH_MODAL:
      return { ...state, showPathModal: payload };
    case SET_TRIGGERED_GUARDRAIL:
      return { ...state, triggeredGuardrail: payload };
    case SET_ADD_STEP:
      return { ...state, addStep: payload };
    case SELECTED_ROUTINE:
      return { ...state, selectedRoutine: payload };
    case AUTO_DRIVE_MONITOR_ERROR_CODES:
      return { ...state, autoDriveMonitorErrorCodes: payload };
    case AUTO_DRIVE_ERROR:
      return { ...state, autoDriveError: payload };
    case SHOW_TRACTOR_START:
      return { ...state, showTractorStart: payload };
    case SHOW_TRACTOR_COMMAND_LOADER:
      return { ...state, showTractorCommandLoader: payload };
    case SNAP_SHOT_INITIATED:
      return { ...state, snapShotInitiated: payload };
    case SET_SHOW_SNAPSHOT:
      return { ...state, showSnapshot: payload };
    case AUTO_DRIVE_LOGOUT_ERROR_CODES:
      return { ...state, autoDriveLogoutErrorCodes: payload };
    case SET_PINNED_TRACTORS:
      return { ...state, pinnedTractors: payload };
    case SET_SHOW_TERM_AND_COND:
      return { ...state, showTermAndCond: payload };
    case SET_SHOW_ROUTINE:
      return { ...state, showRoutine: payload };
    case SET_AUTO_DRIVE_INTERRUPT_MESSAGES:
      return { ...state, autoDriveInterruptMsgs: payload };
    case SET_AUTO_DRIVE_MONITOR_POP:
      return { ...state, autoDriveMonitorPop: payload };
    case SET_AUTO_DRIVE_POP:
      return { ...state, showAutoDrivePop: payload };
    case SET_AUTO_DRIVE_FEEDBACK_POP:
      return { ...state, showAutoDriveFeedBackPop: payload };
    case SET_AUTO_DRIVE_FEEDBACK_PAYLOAD:
      return { ...state, feedBackPayload: payload };
    case SET_SHOW_CONNECT_LOADER:
      return { ...state, showConnectLoader: payload };
    case SET_SELECTED_TRACTOR_LOCATION:
      return { ...state, selectedTractorLocation: payload };
    case SET_SELECTED_OPENED_FLEET_TAB:
      return { ...state, selectedOpenedFleetTab: payload };
    case SET_LOADER_FOR_IMPLEMENT_CHANGE:
      return { ...state, loaderForImplementChange: payload };
    case SET_ACTIVE_AUTODRIVE_TAB:
      return { ...state, activeAutoDriveTab: payload };
    case SET_TRIGGER_TO_STARTING_POINT:
      return { ...state, triggerToStartingPoint: payload };
    case SET_SHOW_CONNECT_TRY_AGAIN_POP:
      return { ...state, showConnectTryAgainPop: payload };

    case SHOW_AUTO_DRIVE_POOR_CONNECTIVITY_LOADER:
      return { ...state, showAutoDrivePoorConnectivityLoader: payload };
    case SET_WAY_POINTS_FOR_REMOTE_AV:
      return { ...state, waypointsForRemoteAv: payload };
    case SET_AUTO_DRIVE_LOADER:
      return { ...state, autoDriveLoader: payload };
    case SET_FEED_LANES:
      return { ...state, feedLanes: payload };
    case SET_SELECTED_FEED_LANES:
      return { ...state, selectedFeedLanes: payload };
    case SET_FEED_AMOUNT:
      return { ...state, feedAmount: payload };

    // case SET_SELECTED_IMPLEMENT_WIDTH:
    //   return { ...state, selectedImplementWidth: payload };
    // case SET_SHOW_IMPLEMENT_HANDLER:
    //   return { ...state, showImplementWidthHandler: payload };

    case RESET_STATE:
      return initialState;
    case 'change_title':
      return { ...state, title: 'Changed RemoteDriveContext' };

    default:
      throw new Error();
  }
}
